import { SelectSearchModule } from './../../shared/fi-select-search/select-search.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Statistic2ReportParameterEditDialogComponent } from './statistic2-report-parameter-edit-dialog/statistic2-report-parameter-edit-dialog.component';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { FiAppTextSharedModule } from '@fi-shared/app-text';
import { Statistic2ReportParameterEditComponent } from './statistic2-report-parameter-edit/statistic2-report-parameter-edit.component';
import { FiOptionsModule } from '@fi-shared/fi-options/fi-options.module';
import { FormsModule } from '@angular/forms';
import { FiDatePickerModule } from '@fi-shared/fi-date-picker';
import { FiLoadingModule } from '@fi-shared/fi-loading/fi-loading.module';
import { Statistic2ReportViewModule } from '@fi-app/statistic2/statistic2-report-view/statistic2-report-view.module';
import { MatOptionModule } from '@angular/material/core';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        MatButtonModule,
        MatCheckboxModule,
        FiAppTextSharedModule,
        FiOptionsModule,
        FiDatePickerModule,
        FiLoadingModule,
        Statistic2ReportViewModule,
        MatOptionModule,
        SelectSearchModule,
    ],
    declarations: [Statistic2ReportParameterEditDialogComponent, Statistic2ReportParameterEditComponent],
})
export class Statistic2ReportParameterEditModule {}
